import { createContext } from 'react';

export const OrderWAPhoneEmptyContext = createContext<boolean>(false)